import { Component, OnDestroy, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-number-input-renderer',
  template: `
    <input style="padding:10px 0;"
      type="number"
      [id]="childIndex"
      class="form-control"
      (keydown.Tab)="onKey($event)"
      [(ngModel)]="inputValue"
      (change)="onChange($event)"
      step="any"
      [id]="childIndex"
    />
  `,
  styles: [],
})
export class NumberInputRendererComponent
  implements ICellRendererAngularComp, OnDestroy
{
  private params: any;
  inputValue: any;
  isEdit: boolean = false;
  fromMixing: boolean = false;
  childIndex: string = 'false';

  refresh(params: any): any {
    this.isEdit = params.node.edit;
  }

  agInit(params: any): void {
    this.childIndex = `input${params.node.childIndex}`;
    this.fromMixing = params.node.fromMixing;
    this.params = params;
    this.inputValue = params.value;
    if (!this.inputValue || params.node.edit) this.isEdit = true;
  }
  onChange($event: any): any {
    if (this.params.onChange instanceof Function) {
      // put anything into params u want pass into parents component
      this.params.node.data[this.params.column.getColId()] = this.inputValue;

      const params = {
        event: $event,
        rowData: this.params.node.data,
        index: this.params.node.rowIndex,
        // ...something
      };
      this.params.onChange(params);
    }
  }
  onKey($event: any): any {
    if (this.params.onKey instanceof Function) {
      this.params.onKey(this.params);
    }
  }
  ngOnDestroy(): any {
    // no need to remove the button click handler
    // https://stackoverflow.com/questions/49083993/does-angular-automatically-remove-template-event-listeners
  }
}
